"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SnapshotConverter_1 = require("./conversions/SnapshotConverter");

var SnapshotConverterImpl_1 = require("./conversions/SnapshotConverterImpl");
/**
 * Configures snapshot app module
 */


var SnapshotAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(SnapshotAppModule, _AppModule_1$AppModul);

  function SnapshotAppModule() {
    var _this;

    _classCallCheck(this, SnapshotAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SnapshotAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'snapshotAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SnapshotAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SnapshotConverter_1.SnapshotConverter).to(SnapshotConverterImpl_1.SnapshotConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return SnapshotAppModule;
}(AppModule_1.AppModule);

exports.SnapshotAppModule = SnapshotAppModule;